
import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
  }
}